import { Select } from '@truepill/react-capsule'
import { getAdornment } from '../CreateRuleSetPage'

const OPERATOR_OPTIONS = {
  string: [
    { label: 'Equals', value: 'equals' },
    { label: 'Not Equals', value: 'not_equals' },
    { label: 'Greater Than', value: 'greater_than' },
    { label: 'Less Than', value: 'less_than' },
  ],
  array: [
    { label: 'In', value: 'in' },
    { label: 'Not In', value: 'not_in' },
  ],
}

const OperatorSelect = ({
  value,
  onChange,
  type,
  state,
  helperText,
  valuesType,
}: {
  value: string | null
  onChange: (val: string) => void
  type: string | null
  state: 'error' | 'default'
  helperText?: string
  valuesType?: string | null
}) => {
  let options = OPERATOR_OPTIONS.string
  if (type === 'MULTIPLE_VALUE' && valuesType === 'array') {
    options = OPERATOR_OPTIONS.array
  }
  return (
    <Select
      label="Operator"
      value={options.find(opt => opt.value === value) || null}
      onChange={selected => {
        if (!selected) return
        onChange(selected.value)
      }}
      options={options}
      selectedKey="label"
      state={state}
      helperText={helperText}
      endAdornment={getAdornment(
        'Operator used to compare the field with the value(s). Available options depend on the type you selected.',
      )}
    />
  )
}

export default OperatorSelect
